/** Stable authenticated-owner namespace; bearer credentials never influence keys. */
export function storySessionKey(
  userId: string | number | null | undefined,
): string {
  if (userId === null || userId === undefined || userId === "") {
    return "anonymous";
  }
  return `user-${String(userId)}`;
}
